import React from 'react';
import Logger from '@lmig/dotcom-utilities-helpers/logger';
import { IconProps } from '@lmig/lmds-react';
import { ICON_NAMES, getDynamicIcon } from './iconChunks';

interface LmdsIconProps extends IconProps {
  icon?: string;
}

const logger = new Logger('client:components:Icon:LmdsIcons');

// eslint-disable-next-line react/jsx-no-useless-fragment
const emptyIcon = () => <></>;

const LmdsIcon: React.FC<LmdsIconProps> = ({ icon = '', ...rest }) => {
  let CurrentIcon;

  if (icon && ICON_NAMES.includes(icon)) {
    CurrentIcon = getDynamicIcon(icon);
  } else {
    logger.warn(`Cannot find ${icon} icon.`);
    CurrentIcon = emptyIcon;
  }

  return <CurrentIcon aria-label={icon} size={rest.size} {...rest} />;
};

export default LmdsIcon;
